import { cn } from '@qodo/design-system';
import { ExternalLink as ExternalLinkIcon } from 'lucide-react';

export const InstallAppNextLabel = ({ text }: { text: string }) => (
  <>
    {text}
    <ExternalLinkIcon
      className={cn(
        'ml-1.5 -translate-y-[1px] stroke-icon-interactive-neutral-active',
      )}
      size="16px"
    />
  </>
);
